// @ts-ignore svg import
import FlowerCoins from 'bender-url!pricing-pages-ui-components/js/hsocImages/flower_coins.svg';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { useMediaBySize } from '../hooks/useMedia';
import AIAgentsCarousel from './AIAgentsCarousel';
import CreditsExplainerFeatures from './CreditsExplainerFeatures';
import CreditsExplainerHeader from './CreditsExplainerHeader';
import { ExplainerSectionWrapper } from './ExplainerSectionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HsocCreditsExplainer = ({
  agents,
  onLinkClick,
  onCarouselClick,
  onCarouselScroll
}) => {
  const isCanvas = isCanvasTheme(useTheme());
  const isSmOrBigger = useMediaBySize('sm');
  const isLgOrBigger = useMediaBySize('lg');
  return /*#__PURE__*/_jsx(ExplainerSectionWrapper, {
    id: "credits-explainer",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: isLgOrBigger ? 'row' : 'column',
      flexWrap: isLgOrBigger ? 'wrap' : undefined,
      children: [/*#__PURE__*/_jsxs(Flex, {
        flex: 54,
        flexDirection: "column",
        minInlineSize: isLgOrBigger ? '500px' : undefined,
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "start",
          children: [/*#__PURE__*/_jsx(Flex, Object.assign({}, isSmOrBigger ? {
            paddingInlineStart: '1200',
            paddingBlockStart: '1000',
            paddingBlockEnd: '600'
          } : {
            padding: '500'
          }, {
            children: /*#__PURE__*/_jsx(CreditsExplainerHeader, {})
          })), isSmOrBigger && /*#__PURE__*/_jsx(Flex, {
            position: "relative",
            insetBlockEnd: "-24px",
            blockSize: "100%",
            minBlockSize: "200px",
            inlineSize: "100%",
            minInlineSize: "200px",
            marginBlockStart: "auto",
            children: /*#__PURE__*/_jsx(Image, {
              src: FlowerCoins,
              alt: "",
              position: "absolute",
              insetBlockEnd: "0",
              insetInlineEnd: "0"
            })
          })]
        }), /*#__PURE__*/_jsx(View, {
          flex: 1,
          "data-style": "bg-teal-13",
          backgroundColor: isCanvas ? 'fill-accent-neutral-pressed' : 'fill-primary-hover',
          padding: isSmOrBigger ? '1200' : '500',
          children: /*#__PURE__*/_jsx(CreditsExplainerFeatures, {})
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        flex: 46,
        minInlineSize: isLgOrBigger ? '430px' : undefined,
        children: /*#__PURE__*/_jsx(AIAgentsCarousel, {
          agents: agents,
          onLinkClick: onLinkClick,
          onCarouselClick: onCarouselClick,
          onCarouselScroll: onCarouselScroll
        })
      })]
    })
  });
};
export default HsocCreditsExplainer;